import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const sections = t('legal.privacy.sections', { returnObjects: true });
  const sectionList = Array.isArray(sections) ? sections : [];

  return (
    <>
      <Helmet>
        <title>{t('legal.privacy.title')} - HirePortal</title>
        <meta name="description" content={t('legal.privacy.metaDescription')} />
      </Helmet>
      <div className="min-h-screen bg-white text-foreground">
        <div className="border-b border-border bg-[#f7f8fb]">
          <div className="mx-auto max-w-3xl px-5 py-10 md:py-16">
            <Link
              to="/authentication"
              className="mb-8 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            >
              <Icon name="ArrowLeft" size={16} />
              {t('legal.back')}
            </Link>

            <p className="text-xs font-semibold uppercase tracking-widest text-primary">
              {t('legal.privacy.kicker')}
            </p>
            <h1 className="mt-3 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              {t('legal.privacy.title')}
            </h1>
            <p className="mt-3 text-sm text-muted-foreground">
              {t('legal.privacy.updated')}
            </p>
            <p className="mt-6 text-sm leading-relaxed text-muted-foreground">
              {t('legal.privacy.intro')}
            </p>
          </div>
        </div>

        <div className="mx-auto max-w-3xl px-5 py-14">
          <div className="space-y-9">
            {sectionList.map((section) => (
              <section key={section.title}>
                <h2 className="text-lg font-semibold tracking-tight text-foreground">
                  {section.title}
                </h2>
                {(section.paragraphs ?? []).map((paragraph) => (
                  <p key={paragraph} className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {paragraph}
                  </p>
                ))}
                {section.table?.headers?.length ? (
                  <div className="mt-4 overflow-x-auto rounded-lg border border-border">
                    <table className="w-full min-w-[42rem] border-collapse text-left text-sm">
                      <thead className="bg-[#f7f8fb]">
                        <tr>
                          {section.table.headers.map((header) => (
                            <th
                              key={header}
                              className="border-b border-border px-4 py-3 font-semibold text-foreground"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {section.table.rows.map((row) => (
                          <tr key={row[0]} className="border-b border-border last:border-b-0">
                            {row.map((cell) => (
                              <td
                                key={cell}
                                className="px-4 py-3 align-top leading-relaxed text-muted-foreground"
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </section>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
